import React, { useContext, useEffect, useState } from 'react';
import { Grid, Divider } from '@nextiva/next-ui-components';

import { useSelector } from 'react-redux';
import Hint from 'components/Hint';
import { LICENSES_ASSIGNED_USER } from 'constants/toolTips';

import { FeatureContext } from 'components/AccessResolvers/featureContext';
import { NoLicenseInfo } from '../../Notifications/NoLicenseInfo';
import { NoLicenseWarn } from '../../Notifications/NoLicenseWarn';
import { IsVoiceNoLicenseWarn } from '../../Notifications/IsVoiceNoLicenseWarn';
import { UserDrawerContext } from '../../../UserDrawerContent/UserDrawerContext';

import LicenseRows from './LicenseRows';
import { AddLicense } from './AddLicense';
import { PurchaseAdditionalLicensesBanner } from './PurchaseAdditionalLicenses/PurchaseAdditionalLicensesBanner.tsx';

export const LicenseSection = ({ unsavedUserChanges, saveChanges }) => {
  const {
    featureState: { purchaseLicenseFlow },
  } = useContext(FeatureContext);
  const {
    userDrawerState: {
      assignedLicenses,
      licensesToAdd,
      removedVoiceAccess,
      removedNextOsAccess,
    },
  } = useContext(UserDrawerContext);

  const purchaseLicenseFlowGrantStatus = useSelector(
    (state) =>
      state.globalPolicyDecisionRequestState.purchaseLicenseFlowGrantStatus,
  );
  const accountV2Summary = useSelector(
    (state) => state.globalAccountV2SummaryState.globalAccountV2Summary,
  );
  const inAppPurchaseEnabled =
    accountV2Summary?.attributes?.inAppPurchaseEnabled === 'true' ||
    accountV2Summary?.attributes?.inAppPurchaseEnabled === true;
  const freemiumFlowEnabled =
    accountV2Summary?.attributes?.freemium === 'true' ||
    accountV2Summary?.attributes?.freemium === true;

  const isPurchaseLicenseFlowEnabled =
    purchaseLicenseFlow &&
    inAppPurchaseEnabled &&
    purchaseLicenseFlowGrantStatus &&
    !freemiumFlowEnabled;

  const [hasLicenses, setHasLicenses] = useState(false);
  const [toAddLicenses, setToAddLicenses] = useState(false);
  const [removedVoiceLicense, setRemovedVoiceLicense] = useState(false);
  const [removedLastLicense, setRemovedLastLicense] = useState(false);

  useEffect(() => {
    if (!assignedLicenses) return;
    const licenses = assignedLicenses.length > 0;
    const addLicenses = licensesToAdd.length > 0;

    setHasLicenses(licenses);
    setToAddLicenses(addLicenses);

    setRemovedVoiceLicense(removedVoiceAccess);
    setRemovedLastLicense(removedNextOsAccess);
  }, [
    assignedLicenses,
    licensesToAdd,
    removedVoiceAccess,
    removedNextOsAccess,
  ]);

  const LicensesMessage = () => {
    switch (true) {
      case removedLastLicense:
        return <NoLicenseWarn />;
      case removedVoiceLicense:
        return <IsVoiceNoLicenseWarn />;
      case hasLicenses || toAddLicenses:
        return (
          <>
            <Hint
              tool="LICENSES ASSIGNED TO THIS USER"
              tip={LICENSES_ASSIGNED_USER}
            />
            <Divider />
          </>
        );
      default:
        return isPurchaseLicenseFlowEnabled ? (
          <PurchaseAdditionalLicensesBanner
            unsavedUserChanges={unsavedUserChanges}
            saveChanges={saveChanges}
          />
        ) : (
          <div
            className="Hint-Emphasis m-user-edit-drawer-section__text"
            data-testid="PlatformAdminUI-UsersLink-LicenseSection-LicensesDescription"
          >
            <NoLicenseInfo />
          </div>
        );
    }
  };

  return (
    <Grid container>
      <div className="m-user-edit-drawer-section">
        <Grid item xs={12}>
          <LicensesMessage />
        </Grid>
        {(licensesToAdd.length > 0 || assignedLicenses.length > 0) && (
          <Grid item xs={12}>
            <LicenseRows />
          </Grid>
        )}
        <Grid item xs={12}>
          <AddLicense
            unsavedUserChanges={unsavedUserChanges}
            saveChanges={saveChanges}
          />
        </Grid>
      </div>
    </Grid>
  );
};
